/* Kaiser KG – Plus/Minus in den Produktkacheln (ohne jQuery)
   Zustand pro Variante, entprellte Warenkorb-Aktualisierung über /cart/update.js.
   Schnelle Mehrfachklicks: Server-Antworten überschreiben die Anzeige nur, wenn keine neueren Klicks offen sind. */
(function () {
  'use strict';

  var DEBOUNCE_MS = 250;
  var state = {};    // variantId -> Menge
  var timers = {};   // variantId -> Timeout
  var pending = {};  // variantId -> Anzahl noch offener Requests
  var inflight = Promise.resolve();

  try {
    var st = document.createElement('style');
    st.textContent = '.kk-qty__btn{touch-action:manipulation;-webkit-tap-highlight-color:transparent;user-select:none;-webkit-user-select:none;}';
    document.head.appendChild(st);
  } catch (e) {}

  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  function boxes(variantId) {
    return document.querySelectorAll('[data-kk-qty][data-variant-id="' + variantId + '"]');
  }

  function busy(id) { return !!timers[id] || (pending[id] || 0) > 0; }

  function render(variantId) {
    var qty = state[variantId] || 0;
    boxes(variantId).forEach(function (box) {
      box.setAttribute('data-qty', qty);
      var c = box.querySelector('[data-kk-count]');
      if (c) c.textContent = qty;
      box.classList.toggle('kk-qty--active', qty > 0);
    });
  }

  function updateHeaderCount(count) {
    document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
      el.setAttribute('data-header-cart-count', count > 0 ? count : '');
      el.classList.toggle('visible', count > 0);
    });
  }

  function syncFromCart(cart) {
    var seen = {};
    cart.items.forEach(function (i) { seen[i.variant_id] = (seen[i.variant_id] || 0) + i.quantity; });
    document.querySelectorAll('[data-kk-qty]').forEach(function (box) {
      var id = box.getAttribute('data-variant-id');
      if (busy(id)) return; // neuere Klicks offen: Anzeige nicht zurücksetzen
      state[id] = seen[id] || 0;
      render(id);
    });
    updateHeaderCount(cart.item_count);
  }

  function loadCart() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(syncFromCart)
      .catch(function () {});
  }

  function push(variantId) {
    timers[variantId] = null;
    pending[variantId] = (pending[variantId] || 0) + 1;
    inflight = inflight.then(function () {
      var updates = {}; updates[variantId] = state[variantId] || 0; // immer neueste Menge senden
      return fetch(root() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ updates: updates })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart update failed');
        return r.json();
      }).then(function (cart) {
        pending[variantId]--;
        // Shopify begrenzt auf den Lagerbestand: tatsächliche Menge übernehmen (sobald nichts mehr offen ist)
        syncFromCart(cart);
        document.dispatchEvent(new CustomEvent('kaiser:cart-updated', { detail: cart }));
      }).catch(function () { pending[variantId]--; return loadCart(); });
    });
  }

  function change(box, delta) {
    var id = box.getAttribute('data-variant-id');
    var current = state[id] != null ? state[id] : parseInt(box.getAttribute('data-qty'), 10) || 0;
    state[id] = Math.max(0, current + delta);
    render(id);
    clearTimeout(timers[id]);
    timers[id] = setTimeout(function () { push(id); }, DEBOUNCE_MS);
  }

  document.addEventListener('click', function (e) {
    var plus = e.target.closest('[data-kk-plus]');
    var minus = e.target.closest('[data-kk-minus]');
    if (!plus && !minus) return;
    e.preventDefault();
    e.stopPropagation();
    var box = (plus || minus).closest('[data-kk-qty]');
    if (box) change(box, plus ? 1 : -1);
  }, true);

  // Doppelklick-Zoom/Textmarkierung bei schnellem Tippen verhindern
  document.addEventListener('dblclick', function (e) {
    if (e.target.closest && e.target.closest('.kk-qty__btn')) e.preventDefault();
  }, true);

  // Neu geladene Kacheln (Filter, Nachladen) und Zurück-Navigation abgleichen
  window.addEventListener('pageshow', loadCart);
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-kk-qty]').forEach(function (box) {
      var id = box.getAttribute('data-variant-id');
      state[id] = parseInt(box.getAttribute('data-qty'), 10) || 0;
    });
  });
})();

/* Kaiser KG – Nachkommastellen hochgestellt (Kacheln und Produktseite) */
(function () {
  'use strict';
  var RE = /^(\s*[^\d\s]*\s*)(\d[\d.,\s]*?)[.,](\d{2})(\s*[^\d]*?)\s*$/;
  function format(el) {
    if (el.querySelector('sup.kk-cents')) return;
    if (el.children.length) return;
    var m = RE.exec(el.textContent);
    if (!m) return;
    el.textContent = '';
    if (m[1].trim()) el.appendChild(document.createTextNode(m[1].trim() + ' '));
    el.appendChild(document.createTextNode(m[2]));
    var s = document.createElement('sup');
    s.className = 'kk-cents';
    s.textContent = m[3];
    el.appendChild(s);
    if (m[4].trim()) el.appendChild(document.createTextNode(' ' + m[4].trim()));
  }
  var SEL = '.price__current .money, .price__compare-at .money, .cart-item--content-price .money, .cart-item__total .money';
  function run(root) { (root || document).querySelectorAll(SEL).forEach(format); }
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; run(); });
  }
  document.addEventListener('DOMContentLoaded', function () {
    run();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  });
})();
